const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api-dev-kit.test.wisr.tech";

export const PUBLISH_ENDPOINT = `${BASE_URL}/api/events/publish`;
export const SWAGGER_JSON = `${BASE_URL}/swagger/v1/swagger.json`;
export const NUGET_VERSIONS_ENDPOINT = `${BASE_URL}/api/nuget-versions`;
export const CONNECTIONS_ENDPOINT = `${BASE_URL}/api/service-bus-connections`;
export const WISR_EVENTS_PREFIX = "Wisr.Events.";
export const APP_COORD_PREFIX = "Wisr.Application.Coordinator.Events";
